<template>
	<div :class="appContentClass">
		<slot></slot>
	</div>
</template>

<script>
export default {
	computed: {
		appContentClass() {
			return [
				'app-content',
				{ 'app-content--empty-header': this.isEmptyHeader },
				{ 'app-content--empty-footer': this.isEmptyFooter },
			];
		},
	},
};
</script>
